module.exports = __webpack_public_path__ + "img/informasi-rekening.8f0f4760.svg";